export const formatContactName = (contact, fallBack = "") => {
    return contact ? `${contact.title} ${contact.firstName} ${contact.lastName}` : fallBack;
}

export const formatContactEmail = (contact, fallBack = "") => {
    return contact ? contact.email : fallBack;
}